function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Decimal from 'decimal.js';
import { PriceIncreaseModel } from "../PriceIncreaseModel";
import { ServiceCostType } from "./model";
export function makeFixedCost(price) {
  var _opts$discount, _opts$discount2, _opts$discount3;
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isDiscountExpired = (_opts$discount = opts.discount) === null || _opts$discount === void 0 || (_opts$discount = _opts$discount.expiration()) === null || _opts$discount === void 0 ? void 0 : _opts$discount.isExpired();
  return {
    pricingType: ServiceCostType.Fixed,
    price: new Decimal(price),
    discount: isDiscountExpired ? null : (_opts$discount2 = opts.discount) !== null && _opts$discount2 !== void 0 ? _opts$discount2 : null,
    priceIncrease: opts.priceIncrease || PriceIncreaseModel.makeNone(),
    expiredDiscount: isDiscountExpired ? (_opts$discount3 = opts.discount) !== null && _opts$discount3 !== void 0 ? _opts$discount3 : null : null
  };
}
export function makeVariableCost(price) {
  var _discount$expiration;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    unitCap,
    unitName,
    preapprovedControlledByAdvancedSettings,
    discount,
    priceIncrease
  } = options;
  const isDiscountExpired = discount === null || discount === void 0 || (_discount$expiration = discount.expiration()) === null || _discount$expiration === void 0 ? void 0 : _discount$expiration.isExpired();
  return _objectSpread({
    pricingType: ServiceCostType.Variable,
    price: new Decimal(price),
    unitCap: unitCap != null ? new Decimal(unitCap) : null,
    unitName: unitName || null,
    discount: isDiscountExpired ? null : discount !== null && discount !== void 0 ? discount : null,
    priceIncrease: priceIncrease || PriceIncreaseModel.makeNone(),
    expiredDiscount: isDiscountExpired ? discount !== null && discount !== void 0 ? discount : null : null
  }, typeof preapprovedControlledByAdvancedSettings === 'boolean' && {
    preapprovedControlledByAdvancedSettings
  });
}
export function makeRangeCost(maxPrice) {
  var _discount$expiration2;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    minPrice,
    discount,
    priceIncrease
  } = options;
  const isDiscountExpired = discount === null || discount === void 0 || (_discount$expiration2 = discount.expiration()) === null || _discount$expiration2 === void 0 ? void 0 : _discount$expiration2.isExpired();
  return {
    pricingType: ServiceCostType.Range,
    maxPrice: new Decimal(maxPrice),
    minPrice: minPrice != null ? new Decimal(minPrice) : null,
    discount: isDiscountExpired ? null : discount !== null && discount !== void 0 ? discount : null,
    priceIncrease: priceIncrease || PriceIncreaseModel.makeNone(),
    expiredDiscount: isDiscountExpired ? discount !== null && discount !== void 0 ? discount : null : null
  };
}